/**
 * Created by staffanrantzow on 15/04/16.
 */

import Utils from 'frilans-finans/utils/utils';
import moment from 'moment';
class Service {

  /**
   * Set end-date to one day later.
   */
  fixDate (dateFilter) {
    var start, end;

    start = moment(dateFilter.startDate).startOf('day').format();
    end = moment(dateFilter.endDate).add(1, 'days').startOf('day').format();

    return {
      startDate: start,
      endDate: end
    };
  }

  getFilterDate (dateFilter, column) {
    if (dateFilter) {
      var dates = this.fixDate(dateFilter);

      return `?filter[${column}][${encodeURIComponent('>=')}][]=${Utils.formatDate(dates.startDate)}` +
        `&filter[${column}][${encodeURIComponent('<=')}][]=${Utils.formatDate(dates.endDate)}`;
    }
    return '?';
  }

}

export default Service;



/** WEBPACK FOOTER **
 ** ./src/frilans-finans/service/service.js
 **/